module.exports = __webpack_public_path__ + "static/img/花瓶9.687de15.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶9.png
// module id = iW5Q
// module chunks = 2